import { PublicRecord } from '../components/PublicRecord.tsx';

/** The public honesty ledger's own route (T-094) — signed-out reachable, the
 * same exception `/fixtures` and `/try` already carve out in `App.tsx`; a
 * signed-in visitor sees the same aggregate too, just inside the normal
 * `AppShell` rather than the public one — nothing on this page is
 * per-account, so there's nothing to gate. */
export function RecordPublicRoute() {
  return <PublicRecord />;
}
